
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parent-survey",
      function () {
        return require("private-next-pages/parent-survey/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parent-survey"])
      });
    }
  